let API_VERSION = 'v0';
let TTT_VERSION = '0.0.0';

export default constants => {
  API_VERSION = constants.API_VERSION;
  TTT_VERSION = constants.TTT_VERSION;
};

const PARAM_REGEX = /^sc_/;

export { API_VERSION, TTT_VERSION, PARAM_REGEX };
